import Icon from '@ant-design/icons';
import {
  achLogo,
  cardIcon,
  checkLogo,
  InternationalLogo,
  plaidLogo,
  rppsLogo,
  virtualCardLogo,
  virtualLogo,
  wireLogo
} from '@tools/ui/assets';
import {
  DeliveryMethod,
  DeliveryMethoddeliveryTypeEnumType,
  DeliveryMethodverifiedStatusEnumType,
  Maybe
} from '@tools/ui/types/generated/graphql';
import { toCamelCase } from './stringFormat.util';

export const DeliveryMethodType = {
  ...DeliveryMethoddeliveryTypeEnumType,
  ...DeliveryMethodverifiedStatusEnumType
};

export type source =
  | DeliveryMethoddeliveryTypeEnumType
  | DeliveryMethodverifiedStatusEnumType;

type DeliveryMethodIcon = {
  icon: typeof Icon;
  tooltip: (vendorHasHandle?: Maybe<boolean>) => string;
};

type DeliveryMethodIcons = Record<string, DeliveryMethodIcon>;

export const detectDeliveryMethod = ({
  verifiedStatus,
  deliveryType
}: DeliveryMethod): source => {
  const deliveryTypeFormatted = toCamelCase(deliveryType);

  return deliveryTypeFormatted === DeliveryMethoddeliveryTypeEnumType.ach
    ? DeliveryMethodType[verifiedStatus]
    : DeliveryMethodType[deliveryTypeFormatted];
};

export const DeliveryMethodIcons: DeliveryMethodIcons = {
  [DeliveryMethodType.plaidVerified]: {
    icon: plaidLogo as typeof Icon,
    tooltip: () => 'Plaid'
  },
  [DeliveryMethodType.microDepositVerified]: {
    icon: achLogo as typeof Icon,
    tooltip: (vendorHasHandle) =>
      vendorHasHandle ? 'ACH - MD Verified' : 'ACH'
  },
  [DeliveryMethodType.softVerified]: {
    icon: achLogo as typeof Icon,
    tooltip: (vendorHasHandle) =>
      vendorHasHandle ? 'ACH - MD Verified' : 'ACH'
  },
  [DeliveryMethodType.notVerified]: {
    icon: achLogo as typeof Icon,
    tooltip: (vendorHasHandle) =>
      vendorHasHandle ? 'ACH - MD Unverified' : 'ACH'
  },
  [DeliveryMethodType.check]: {
    icon: checkLogo as typeof Icon,
    tooltip: () => 'Check'
  },
  [DeliveryMethodType.virtual]: {
    icon: virtualLogo as typeof Icon,
    tooltip: () => 'Virtual'
  },
  [DeliveryMethodType.rpps]: {
    icon: rppsLogo as typeof Icon,
    tooltip: () => 'RPPS (Biller directory)'
  },
  [DeliveryMethodType.international]: {
    icon: InternationalLogo as typeof Icon,
    tooltip: () => 'International'
  },
  [DeliveryMethodType.virtualCard]: {
    icon: virtualCardLogo as typeof Icon,
    tooltip: () => 'Virtual card'
  },
  [DeliveryMethodType.domesticWire]: {
    icon: wireLogo as typeof Icon,
    tooltip: () => 'Domestic wire'
  },
  [DeliveryMethodType.card]: {
    icon: cardIcon as typeof Icon,
    tooltip: () => 'Card'
  }
};
